import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = `${import.meta.env.VITE_DOCUMENT_SERVICE_URL}/exports`;
export const axiosInstance = buildAxiosInstance(baseUrl);
export const axios = buildMakeUseAxios(baseUrl);
